import { MemberForm } from '../../../MemberForm'
import useMutationUpdateMember from '@/modules/manage-member/api/hooks/useMutateUpdateMember'
import useQueryGetMemberById from '@/modules/manage-member/api/hooks/useQueryGetMemberById'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import { FormValues } from '../../../MemberForm'
import { UseFormReturn } from 'react-hook-form'
import { handleMemberFormError } from '@/modules/manage-member/utils/handleMemberFormError'
import Spinner from '@/common/components/Spinner'
import { useQueryClient } from '@tanstack/react-query'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'

export function EditMemberForm() {
	const { id } = useParams()
	const navigate = useNavigate()
	const { mutate: updateMember } = useMutationUpdateMember()
	const { data: member, isLoading } = useQueryGetMemberById(id!)
	const queryClient = useQueryClient()

	const onSubmit = (values: FormValues, form: UseFormReturn<FormValues>) => {
		if (!id) return

		const updateValues = {
			username: values.username,
			userGroupId: values.userGroupId,
			...(values.phone ? { phone: values.phone } : {}),
		}

		updateMember(
			{ id, payload: updateValues },
			{
				onSuccess: () => {
					toast.success('แก้ไขผู้ใช้งานสำเร็จ')
					queryClient.invalidateQueries({
						queryKey: [OperatorQueryKeys.GetMemberById, id],
					})
					navigate('/operator/manage-member')
				},
				onError: (error) => handleMemberFormError(error, form, 'edit'),
			},
		)
	}

	if (isLoading || !member) return <Spinner />
	return (
		<MemberForm
			mode="edit"
			defaultValues={{
				username: member.username,
				phone: member.phone,
				userGroupId: member.userGroup.id,
			}}
			onSubmit={onSubmit}
		/>
	)
}
